import React from 'react'
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomTypography from '../CustomComponents/CustomTypography/CustomTypography';
import { useStyles } from "../../assets/jss/TableGenerate";
import { useTranslation } from "react-i18next";
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from '@material-ui/icons/Close';
import DragDrop from './DragDrop';
import { useHistory, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ConfirmActionDialog from '../Dialogs/ConfirmAction/ConfirmAction';
import { setIsCameFromEventDetailsPage } from '../../services/LocalStorageService';

const TableGenerate = (props:any) => {

    const { t } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const params = useParams();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogAction] = useState("save");

    const goBackFunc = () => {
        setIsCameFromEventDetailsPage(1);
        (params.impersonationid && history.length > 1) || !params.impersonationid ? history.goBack() : history.push(`/dashboard/impersonation/${params.impersonationid}`);
    }

    const [locationKeys, setLocationKeys] = useState([]);

    useEffect(() => {
        return history.listen((location) => {
        if (history.action === "PUSH") {
            setLocationKeys([location.key]);
        }
        if (history.action === "POP") {
            if (locationKeys[1] === location.key) {
                setLocationKeys(([_, ...keys]) => keys);
                // Handle forward event
            } else {
                setLocationKeys((keys) => [location.key, ...keys]);
                setIsCameFromEventDetailsPage(1);
                // Handle back event
            }
        }
        });
    }, [locationKeys]);

    const deleteDialogFunc = (isOpen, confirmDelete) => {
        setDialogOpen(isOpen);
        if (confirmDelete) {
            goBackFunc();
        }
    };

    return (
        <>
            {/* Header */}
            <div style={{ overflow: 'auto' }} >
                <div style={{ minWidth: '700px' }}>
                    <CustomGrid
                        container
                        spacing={0}
                        justifyContent="space-between"
                        alignItems="center"
                        className={classes.header}
                    >
                        <CustomGrid item >
                            <CustomTypography className={classes.headerTitle}>
                                {t("CONFIG_NEW_VIEW")}
                            </CustomTypography>
                            <CustomTypography className={classes.headerSubTitle}>
                                {t("YOU_CAN_GENERATE_CUSTOM_GROUP_AND_A_TABLE")}
                            </CustomTypography>
                        </CustomGrid>
                        <CustomGrid item>
                            <IconButton onClick={() => { setDialogOpen(true) }} aria-label="delete" className={classes.margin}>
                                <CloseIcon fontSize="large" />
                            </IconButton>
                        </CustomGrid>
                    </CustomGrid>

                    {/*  main content  */}
                    <DragDrop />

                    {/* Footer  */}
                </div>
            </div>
            <ConfirmActionDialog
                dialogOpen={dialogOpen}
                dialogClose={(isOpen, confirmDelete) =>
                    deleteDialogFunc(isOpen, confirmDelete)
                }
                dialogMessage={t("ARE_YOU_SURE_YOU_WANT_TO_CLOSE_THIS_VIEW_WITHOUT_SAVING_IT")}
                dialogAction={dialogAction}
            />
        </>
    )
}

export default TableGenerate
